import conn from "@/store/utils/connection";
import resulter from "@/store/utils/resulter";
import api from "../apiEndPoint";

export default {
    loadListPerangkat: ({ commit }, payload = { offset: 0, limit: 500 }) => {
        commit("setFetching", true);
        return conn.get(api.getListPerangkat, payload);
    },
    getListPerangkat: ({ commit, dispatch, getters }) => {
        let query = {
            offset: 0,
            limit: 500,
        };
        commit("setFetching", true);
        dispatch("loadListPerangkat", query)
            .then((res) => {
                let { code, data, status, msg } = res.data;
                if (code === 200 && status) {
                    conn.setQueryString(query);
                    commit("setListPerangkat", data);
                    commit("setEndItemofPage", data.array[data.array.length - 1]);
                    commit("setNextPagination", data.array);
                    commit("setResponse", resulter.successResult(msg));
                } else {
                    commit("setResponse", resulter.errorResult(msg));
                }
                commit("setFetching", false);
                commit("setLoadMore", false);
            })
            .catch((e) => {
                commit("setFetching", false);
                commit("setLoadMore", false);
                commit("setResponse", resulter.errorResult(e));
            });
    },
    getListPaket: ({ commit }) => {
        conn.get(api.getListPaket)
            .then((res) => {
                let { status, code, data, msg } = res.data;
                if (code === 200 && status) {
                    commit("setPaketWhatsapp", data);
                    commit("setResponse", resulter.successResult(msg));
                } else {
                    commit("setResponse", resulter.errorResult(msg));
                }
            })
            .catch((e) => {
                commit("setResponse", resulter.errorResult(e));
            });
    },
    getListBank: ({ commit, dispatch }, payload) => {
        conn.get(api.getListBank)
            .then((res) => {
                let { status, code, data, msg } = res.data;
                if (code === 200 && status) {
                    commit("setListBank", data);
                } else {
                    commit("setResponse", resulter.errorResult(msg));
                }
                if (payload.loadDetailTagihan) {
                    dispatch("getDetailTagihan", payload);
                }
            })
            .catch((e) => {
                commit("setResponse", resulter.errorResult(e));
            });
    },
    getVoucher: ({ commit }, { kode }) => {
        let query = {
            kode,
        };
        commit("setFetching", true);
        conn.get(api.getVoucher, query)
            .then((res) => {
                let { status, code, data, msg } = res.data;
                if (code === 200 && status) {
                    commit("setVoucher", data);
                    commit("setResponse", resulter.successResult(msg));
                } else {
                    commit("setVoucher", {});
                    commit("setResponse", resulter.errorResult(msg));
                }
                commit("setFetching", false);
            })
            .catch((e) => {
                commit("setFetching", false);
                commit("setResponse", resulter.errorResult(e));
            });
    },
    registerPerangkat: ({ commit }, payload) => {
        commit("setFetching", true);
        let posted = new FormData();

        Object.keys(payload).forEach(function(key) {
            posted.append(key, payload[key]);
        });

        return conn.post(api.registed, posted, conn.contentType.form);
    },
    updateDeviceDetail: ({ commit }, payload) => {
        commit("setFetching", true);
        let posted = new FormData();

        Object.keys(payload).forEach(function(key) {
            posted.append(key, payload[key]);
        });

        return conn.post(api.updateDeviceDetail, posted, conn.contentType.form);
    },
    updatePaketDevice: ({ commit }, payload) => {
        commit("setFetching", true);
        let posted = new FormData();

        Object.keys(payload).forEach(function(key) {
            posted.append(key, payload[key]);
        });

        return conn.post(api.updatePaketDevice, posted, conn.contentType.form);
    },
    sendTestMessage: ({ commit }, payload) => {
        commit("setFetching", true);
        let posted = new FormData();

        Object.keys(payload).forEach(function(key) {
            posted.append(key, payload[key]);
        });

        return conn.post(api.sendTestMessage, posted, conn.contentType.form);
    },
    setIsconnectDevice: ({ commit, getters }, payload) => {
        commit("setFetching", true);
        let tokenJwt;
        if (!payload.dbreadonly) {
            tokenJwt = getters.jwtToken();
        }

        let query = {
            readonly: tokenJwt?.Readonly || payload.dbreadonly,
            api_key: "am9tYmxvaGdha3BheXU=",
        };

        let posted = new FormData();

        Object.keys(payload).forEach(function(key) {
            posted.append(key, payload[key]);
        });

        Object.keys(query).forEach(function(key) {
            posted.append(key, query[key]);
        });

        conn.post(api.setIsconnectDevice, posted, conn.contentType.form)
            .then((res) => {
                let { status, code, data, msg } = res.data;
                if (code === 200 && status) {
                    commit("setResponse", resulter.successResult(msg));
                } else {
                    commit("setResponse", resulter.errorResult(msg));
                }
                commit("setFetching", false);
            })
            .catch((e) => {
                commit("setFetching", false);
                commit("setResponse", resulter.errorResult(e));
            });
    },
    getDetailTagihan: ({ commit }, { iddevice, idbill }) => {
        let query = {
            idbill,
            iddevice,
        };
        commit("setFetching", true);
        commit("setResponse", {});
        conn.get(api.getDetailTagihan, query)
            .then((res) => {
                let { status, code, data, msg } = res.data;
                if (status && code === 200) {
                    commit("setTagihan", data);
                    commit("setResponse", resulter.successResult(msg));
                } else {
                    commit("setResponse", resulter.errorResult(msg));
                }
                commit("setFetching", false);
            })
            .catch((e) => {
                commit("setFetching", false);
                commit("setResponse", resulter.errorResult(e));
            });
    },
    getDetailDevice: ({ commit, getters }, { id_mesin }) => {
        let tokenJwt = getters.jwtToken();

        let query = {
            readonly: tokenJwt.Readonly,
            api_key: "am9tYmxvaGdha3BheXU=",
        };

        commit("setFetching", true);
        commit("setResponse", {});
        conn.get(`${api.getDetailDevice}/${id_mesin}`, query)
            .then((res) => {
                let { status, code, data, msg } = res.data;
                if (status && code === 200) {
                    commit("setDataDevice", data);
                    commit("setResponse", resulter.successResult(msg));
                } else {
                    commit("setResponse", resulter.errorResult(msg));
                }
                commit("setFetching", false);
            })
            .catch((e) => {
                commit("setFetching", false);
                commit("setResponse", resulter.errorResult(e));
            });
    },
    getDetailTinyDevice: ({ commit, getters }, { id_mesin, dbreadonly }) => {
        let tokenJwt;
        if (!dbreadonly) {
            tokenJwt = getters.jwtToken();
        }

        let query = {
            readonly: tokenJwt?.Readonly || dbreadonly,
            api_key: "am9tYmxvaGdha3BheXU=",
        };

        commit("setFetching", true);
        commit("setResponse", {});
        conn.get(`${api.getDetailTinyDevice}/${id_mesin}`, query)
            .then((res) => {
                let { status, code, data, msg } = res.data;
                if (status && code === 200) {
                    commit("setDataDeviceTiny", data);
                    commit("setResponse", resulter.successResult(msg));
                } else {
                    commit("setResponse", resulter.errorResult(msg));
                }
                commit("setFetching", false);
            })
            .catch((e) => {
                commit("setFetching", false);
                commit("setResponse", resulter.errorResult(e));
            });
    },
    createQr: ({ commit, getters }, { id_mesin, multiperangkat,dbreadonly }) => {
        let tokenJwt;
        if (!dbreadonly) {
            tokenJwt = getters.jwtToken();
        }

        let posted = new FormData();

        posted.append("readonly", tokenJwt?.Readonly || dbreadonly);
        posted.append("api_key", "am9tYmxvaGdha3BheXU=");
        posted.append("multi", multiperangkat);

        commit("setFetching", true);
        commit("setResponse", {});
        conn.post(`${api.recreateWorker}/${id_mesin}`, posted, conn.contentType.form)
            .then((res) => {
                if (res.data === undefined) {
                    conn.post(`${api.createWorker}/${id_mesin}`, posted, conn.contentType.form).then((response) => {
                        let { status, code, data, msg } = response.data;
                        if (status && code === 200) {
                            commit("setResponse", resulter.successResult(msg));
                            commit("setFetching", false);
                        } else {
                            commit("setResponse", resulter.errorResult(msg));
                            commit("setFetching", false);
                        }
                    });
                } else {
                    let { status, code, data, msg } = res.data;
                    if (status && code === 200) {
                        commit("setResponse", resulter.successResult(msg));
                        commit("setFetching", false);
                    } else {
                        commit("setResponse", resulter.errorResult(msg));
                        commit("setFetching", false);
                    }
                }
            })
            .catch((e) => {
                commit("setFetching", false);
                commit("setResponse", resulter.errorResult(e));
            });
    },
    removeDevice: ({ commit }, { id_device }) => {
        commit("setFetching", true);
        commit("setResponse", {});

        return conn.post(`${api.removeDevice}/${id_device}`);
    },
    removeWorker: ({ commit, getters }, { id_device, dbreadonly }) => {
        commit("setFetching", true);
        commit("setResponse", {});

        let tokenJwt;
        if (!dbreadonly) {
            tokenJwt = getters.jwtToken();
        }

        let posted = new FormData();

        posted.append("readonly", tokenJwt?.Readonly || dbreadonly);
        posted.append("api_key", "am9tYmxvaGdha3BheXU=");

        return conn.post(`${api.removeWorker}/${id_device}`, posted, conn.contentType.form);
    },
};
